import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import AggregateShellComponent from "../../../gd-modules/common/aggregate/aggregate-shell";
import formatTime from "../../../gd/format/time";

export default function AggregateMomentDateTimeComponent(options: any, props: any) {

    const isValid = !_.isNil(props.value) && !_.isNaN(props.value);
    const value = isValid ? props.value : null;

    let label, isRange;
    if (value) {
        isRange = !!value.start;
        label = isRange ?
            value.start.format("MMM DD") + " " + formatTime(value.start) + " - " + value.end.format("MMM DD") + " " + formatTime(value.end) :
            value.format("MMM DD") + " " + formatTime(value);
    }

    return (
        <AggregateShellComponent options={options} noData={!isValid} hint={label} {...props}>
            {isValid &&
            <Fragment>
                {!isRange && <div className="aggregate-label">{gd.const.aggregate.label[props.aggregateFunction]}:</div>}
                <div className="aggregate-value aggregate-date">{label}</div>
            </Fragment>}

            {!isValid && <div className="aggregate-value aggregate-no-data">{gd.const.aggregate.label[props.aggregateFunction]}</div>}
        </AggregateShellComponent>
    );
}

AggregateMomentDateTimeComponent.propTypes = {
    value: PropTypes.object //Moment object
}
